import { fGetFunction } from './firebase'

const baseApiUrl = "home"

export function getHomeCharts() {
  return fGetFunction(`${baseApiUrl}/charts`)
}
